<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="other-works-by-the-author">
<h1>Other Works by the Author</h1>
<p><strong><em><span class="underline">The Osgoode Trilogy</span></em></strong></p>
<p><em>Conduct in Question</em></p>
<p><em>Final Paradox</em></p>
<p><em>A Trial of One</em></p>
<p><strong><em><span class="underline">The Trilogy of Remembrance</span></em></strong></p>
<p><em>The Drawing Lesson</em></p>
<p><em>The Fate of Pryde</em></p>
<p><em>Night Crossing.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?3d4ea8c5